import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerApiService } from '../../services/player-api.service';
import { PlayerDataService } from '../../services/player-data.service';
import { UtilsService } from '../../services/utils.service'
import { Router } from '@angular/router';
@Component({
  selector: 'randd-decisions',
  standalone: true,
  imports: [
    CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule
  ],
  templateUrl: './randd-decisions.component.html',
  styleUrl: './randd-decisions.component.css'
})
export class RanddDecisionsComponent implements OnInit, OnDestroy {
  RNDD: any;
  RO: any;
  maxProducts: number = 0;
  platformList: { platformId: number; platformName: string }[] = [];
  selectedPlatform: number | null = null;

  constructor(private router: Router, private api: PlayerApiService, private playerData: PlayerDataService, private utils: UtilsService) { }

  async ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const playerId = user.userId;

    console.log(playerId);

    const cached = await this.playerData.getPageDecisionData('randd') || { ongoingRnD: [], newProducts: [] };
    this.RNDD = cached;
    
    console.log(cached);
    console.log(this.RNDD);
    const roCached = await this.playerData.getPageDecisionData('readonly') || { "RoundSubUnit": "", "APARselectarr": "[]", "maxProducts": 0, "PlatformSelectvals": [] };
    this.RO = roCached;
    console.log(this.RO);
    this.platformList = this.RO.PlatformSelectvals;
    this.maxProducts = this.RO.maxProducts;

    
    // if (this.RNDD.platformId > 0){
    //  this.selectedPlatform = this.RNDD.platformId;
    // }
    // this.router.navigate(['/randd-decisions']);

  }



  onInputChange() {
    console.log("in input change");
    console.log(this.RNDD);
    this.playerData.setPageDecisionData('randd', this.RNDD);
  }

  //toggleCheckbox(row: any, col: string, event: any) {
  //  row[col] = event.target.checked;
  //  this.onInputChange();
  //}

  ngOnDestroy() {
    this.playerData.setPageDecisionData('randd', this.RNDD);
  }

  addNewProduct() {
    //  if (this.RNDD.newProducts.length < this.RO.maxProducts) {
    console.log(this.RNDD);
    this.RNDD.newProducts.push({ productName: '', platformId: null });
    //  }
  }

  removeProduct(index: number) {
    this.RNDD.newProducts.splice(index, 1);
  }

  toggleRnDSelection(RnD: any) {
    // Find the object by its ID (or any unique property)
    if (RnD.completion >= 100) return;  // prevent toggle if completed

  RnD.selected = RnD.selected === 'Y' ? 'N' : 'Y';

  // optional: force Angular change detection if needed
  this.RNDD.ongoingRnD = [...this.RNDD.ongoingRnD];

  // persist to service
  this.playerData.setPageDecisionData('randd', this.RNDD);

    }
}